import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import DraggableResizable from "~/cabinet/vue/interface/draggableResizable/DraggableResizable.vue";


const __default__ = {
    name: "OperatorApplicationSideMenu",
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    right: { type: Boolean },
    padding: { type: Boolean },
    width: {},
    minWidth: {},
    maxWidth: {}
  },
  emits: ["update:width"],
  setup(__props: any, { emit: __emit }) {



let emits = __emit;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DraggableResizable, {
    draggable: false,
    width: __props.width,
    "min-width": __props.minWidth,
    "max-width": __props.maxWidth,
    "onUpdate:width": _cache[0] || (_cache[0] = ($event: any) => (_unref(emits)('update:width', $event))),
    "auto-height": "",
    class: _normalizeClass(['position-relative', 'side-menu', __props.right ? 'right' : 'left', __props.padding ? 'pl-2 pt-2 pb-2' : null]),
    handlers: [__props.right ? 'w' : 'e'],
    style: _normalizeStyle({minWidth: `${Math.max(__props.width, __props.minWidth)}px`})
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["width", "min-width", "max-width", "class", "handlers", "style"]))
}
}

})